import React from 'react';
import { MoonIcon, BrainIcon, EyeOffIcon, SunIcon, HeartIcon, CompassIcon } from 'lucide-react';
export function TransformationSection() {
  return <section className="py-20 bg-white" data-id="element-353">
      <div className="container mx-auto px-4" data-id="element-354">
        <div className="max-w-4xl mx-auto" data-id="element-355">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16 text-purple-800" data-id="element-356">
            Lo Que Cambia Después de 30 Días
          </h2>
          <div className="grid md:grid-cols-2 gap-12" data-id="element-357">
            <div data-id="element-358">
              <h3 className="text-2xl font-semibold mb-8 text-center text-gray-700" data-id="element-359">
                Antes:
              </h3>
              <div className="space-y-6" data-id="element-360">
                <div className="bg-red-50 p-5 rounded-xl shadow-sm flex" data-id="element-361">
                  <div className="mr-4 text-red-500" data-id="element-362">
                    <MoonIcon size={24} data-id="element-363" />
                  </div>
                  <div data-id="element-364">
                    <p className="text-gray-700" data-id="element-365">
                      Noches sin calma, mente encendida.
                    </p>
                  </div>
                </div>
                <div className="bg-red-50 p-5 rounded-xl shadow-sm flex" data-id="element-366">
                  <div className="mr-4 text-red-500" data-id="element-367">
                    <BrainIcon size={24} data-id="element-368" />
                  </div>
                  <div data-id="element-369">
                    <p className="text-gray-700" data-id="element-370">Ansiedad silenciosa.</p>
                  </div>
                </div>
                <div className="bg-red-50 p-5 rounded-xl shadow-sm flex" data-id="element-371">
                  <div className="mr-4 text-red-500" data-id="element-372">
                    <EyeOffIcon size={24} data-id="element-373" />
                  </div>
                  <div data-id="element-374">
                    <p className="text-gray-700" data-id="element-375">
                      Sentir que tu vida es automática, sin dirección.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div data-id="element-376">
              <h3 className="text-2xl font-semibold mb-8 text-center text-purple-800" data-id="element-377">
                Después:
              </h3>
              <div className="space-y-6" data-id="element-378">
                <div className="bg-green-50 p-5 rounded-xl shadow-sm flex" data-id="element-379">
                  <div className="mr-4 text-green-500" data-id="element-380">
                    <SunIcon size={24} data-id="element-381" />
                  </div>
                  <div data-id="element-382">
                    <p className="text-gray-700" data-id="element-383">
                      Calma profunda al despertar.
                    </p>
                  </div>
                </div>
                <div className="bg-green-50 p-5 rounded-xl shadow-sm flex" data-id="element-384">
                  <div className="mr-4 text-green-500" data-id="element-385">
                    <HeartIcon size={24} data-id="element-386" />
                  </div>
                  <div data-id="element-387">
                    <p className="text-gray-700" data-id="element-388">
                      Fe inquebrantable aunque el mundo grite lo contrario.
                    </p>
                  </div>
                </div>
                <div className="bg-green-50 p-5 rounded-xl shadow-sm flex" data-id="element-389">
                  <div className="mr-4 text-green-500" data-id="element-390">
                    <CompassIcon size={24} data-id="element-391" />
                  </div>
                  <div data-id="element-392">
                    <p className="text-gray-700" data-id="element-393">
                      Claridad emocional, enfoque verdadero y propósito vivo en
                      cada paso.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}